<template>
  <Layout>
    <PageTitle />

    <div class="page-padding page-padding-vertical">
      <div class="page-padding page-padding-horizontal">
        <ReportDateConfigure />
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-8">
          <DataBox :loading="loading" :error="error">
            <FinancesChart />
          </DataBox>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'

import FinancesChart from './chart/FinancesChart.vue'
import ReportDateConfigure from './ReportDateConfigure'

import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import { redirectIfDenied } from '@/services/ability.service'
import { FinancesService } from '@/services/finances.service'

import DataBox from '@/components/DataBox.vue'

export default {
  page: {
    title: 'Финансы',
  },
  components: {
    Layout,
    PageTitle: () => import('./PageTitle.vue'),
    FinancesChart,
    ReportDateConfigure,
    DataBox,
  },
  data() {
    return {
      loading: false,
      error: false,
    }
  },
  watch: {
    '$route.query': {
      handler: 'getFinancesReport',
      immediate: true,
    },
  },
  destroyed() {
    this.$store.commit('finances/CLEAR_CURRENT_REPORT')
  },
  methods: {
    /**
     * Send request to backend for get Finances chart data.
     * Then run mutation `finances/SET_CURRENT_REPORT` in vuex.
     *
     * @returns {Object} data Response wrapper. Contains chart data.
     * */
    async getFinancesReport() {
      this.loading = true
      try {
        const params = {
          year: this.$route.query.year ?? CURRENT_YEAR,
          month: this.$route.query.month ?? CURRENT_MONTH,
          domain: this.$route.query.domain,
        }

        const { data } = await FinancesService.getReport(params)

        this.$store.commit('finances/SET_CURRENT_REPORT', data)
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message

        redirectIfDenied.call(this, error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
